import { toast } from "sonner";
import { Eye, ArrowUUpLeft, CircleNotch } from "@phosphor-icons/react";
import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";

const PLAN_LABELS = {
  free: "Free",
  standard: "Standard",
  premium: "Premium",
  pro: "Pro",
  pro_annual: "Pro Annual",
};

export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const [ending, setEnding] = useState(false);

  // Only render when the current user is the real admin AND has impersonation
  // turned on. Regular users and non-impersonating admins see nothing.
  if (!user || user === false) return null;
  const imp = user.impersonating_plan;
  if (!imp) return null;

  const end = async () => {
    setEnding(true);
    try {
      await api.post("/admin/end-impersonation");
      await refresh();
      toast.success("Returned to admin");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setEnding(false);
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] bg-black text-white px-5 py-3 border-2 border-[var(--accent)] shadow-2xl flex items-center gap-4"
      style={{ minWidth: "min(520px, 92vw)" }}
    >
      <div className="flex items-center gap-2">
        <Eye size={16} weight="bold" className="text-[var(--accent)]" />
        <span className="micro-label text-white">Admin preview</span>
      </div>
      <div className="flex-1 text-sm">
        You're viewing the app as a{" "}
        <strong className="text-[var(--accent)]">
          {PLAN_LABELS[imp] || imp} user
        </strong>
        . All plan gates are active.
      </div>
      <button
        onClick={end}
        disabled={ending}
        className="btn-accent whitespace-nowrap"
        data-testid="btn-end-impersonation"
      >
        {ending ? (
          <>
            <CircleNotch size={14} className="animate-spin" weight="bold" />
            Ending…
          </>
        ) : (
          <>
            <ArrowUUpLeft size={14} weight="bold" />
            Return to admin
          </>
        )}
      </button>
    </div>
  );
}
